import { Avatar, SxProps } from '@mui/material'
import React from 'react'
import { getUserTypeFromLocator, stringToColor } from '../../Utils/String';
import { useAppSelector } from '../../Redux/store';
import { useGetClientProfilePictureQuery, useGetClientQuery } from '../../Redux/api/clientApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetTalentProfilePictureQuery, useGetTalentQuery } from '../../Redux/api/talentApi';
import { useUser } from '../../Hooks/useUser';

interface KaziAvatarProps {
    locator?: string;
    first_name?: string;
    last_name?: string;
    company?: string;
    src?: string;
    width?: string;
    sx?: SxProps;
}

export const KaziAvatar = ({locator, first_name, last_name, src, width, sx, company}: KaziAvatarProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const userId = useAppSelector( state => state.Global.userId);
    const userLocator = locator ?? userId!
    // const userType = useAppSelector( state => state.Global.userType);
    const isClient = getUserTypeFromLocator(userLocator) === 'client'
    const {
        data: client
    } = useGetClientQuery((isClient && userLocator) || skipToken);
    const {
        data: talent
    } = useGetTalentQuery((!isClient && userLocator) || skipToken);
    const {
        data: talentProfilePicture
    } = useGetTalentProfilePictureQuery((talent?.profile_picture && userLocator) || skipToken)
    const {
        data: clientProfilePicture
    } = useGetClientProfilePictureQuery((client?.profile_picture && userLocator) || skipToken)
    
    const firstName = first_name ?? (isClient ? client?.first_name : talent?.first_name)
    const lastName = last_name ?? (isClient ? client?.last_name : talent?.last_name)
    const profilePicture = src ?? (isClient ? clientProfilePicture : talentProfilePicture)
    const name = company || firstName + (lastName ?? '')
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Avatar
            alt={ (`${name}`)}
            src={profilePicture}
            sx={{width: (width  ?? '120px'), height: (width  ?? '120px'), bgcolor: stringToColor(userLocator), ...sx}}
            children={((company && company.substring(0,1)) || `${firstName?.substring(0,1)}${lastName?.substring(0,1)}`)}
        />
    )
}
